<template lang='pug'>
//- SideEffect-Diet
div(:class='$style[`cc-side-effect-diet`]')
  //- 狀態列
  div(:class='$style[`cc-side-effect-diet-wrap`]')
    div(v-if='subscribeVip !== `yes`' :class='$style[`cc-side-effect-diet-main`]')
      header.font-bold(v-if='rwdType !== "desktop"') 飲食管家
      div(:class='$style[`cc-side-effect-diet-tutorial`]')
        div(:class='$style[`cc-side-effect-diet-tutorial-wrap`]')
          figure(:class='$style[`cc-side-effect-diet-tutorial-graphic`]')
            img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')
          span.font-medium 本功能為VIP會員限定，請先訂閱。
          router-link.btn-extra.font-medium(
            title='升級VIP會員'
            tabindex='0' aria-label='升級VIP會員'
            :to='`/shop/subscribe`'
            :class='$style[`cc-side-effect-diet-tutorial-close`]') 立即訂閱

    div(v-else :class='$style[`cc-side-effect-diet-main`]')
      header.font-bold(v-if='rwdType !== "desktop"') 飲食管家
      div(:class='$style[`cc-side-effect-diet-title`]')
        span.font-medium(:class='$style[`cc-side-effect-diet-title-text`]') 辨識營養價值
        span(:class='$style[`cc-side-effect-diet-title-text-tip`]') 照片內容: 餐點、食物、飲品。

      div(:class='$style[`cc-side-effect-diet-content`]')
        div(:class='$style[`cc-side-effect-diet-uploader`]')
          div(:class='$style[`cc-side-effect-diet-uploader-btn`]')
            div(v-if='foodScanSrc' :class='$style[`cc-uploader-area`]')
              button(
                tabindex='0'
                aria-label='移除圖片'
                :class='$style[`cc-uploader-delete-btn`]' @click='foodScan = null; foodScanSrc = ``')
                IconDelete(:size='16' :color='`#b1b1b1`')
                span 移除
              img(:src='foodScanSrc' width='100%')

            div(v-else :class='[$style[`cc-uploader-area`], $style[foodScanError ? `cc-uploader-error` : ``]]')
              input(
                type='file'
                ref='photo'
                name='photo'
                :class='$style[`cc-uploader-inputer`]'
                @change='handlefoodScanUpload')
              div(:class='$style[`cc-uploader-interface`]')
                IconAttachFile(:size='40' :color='`#262626`')
                div(:class='$style[`cc-uploader-interface-title`]')
                  span.font-bold(:class='$style[`cc-uploader-interface-title-text`]') 上傳食物照片
                  span.font-medium(v-if='foodScanError' :class='$style[`cc-uploader-interface-title-sub-text-alert`]') {{ showFoodErrorTip }}
                  span.font-medium(v-else :class='$style[`cc-uploader-interface-title-sub-text`]') (務必清楚看得到食物)

          div(:class='$style[`cc-side-effect-diet-form-control`]')
            div(:class='$style[`cc-side-effect-diet-form-control-left`]')
              button(
                title='重置'
                tabindex='0' aria-label='重置'
                :class='$style[`cc-side-effect-diet-controller-return`]'
                @click='resetSourceOrigin')
                IconRefresh(:size='18' :color='`#262626`')
                != '重置'

              button.btn-confirm-extra(
                title='辨識分析'
                tabindex='0' aria-label='辨識分析'
                :class='[$style[`cc-side-effect-diet-controller-send`], $style[foodScanSrc ? `` : `disabled`]]'
                @click='debounceStartRecognize') 辨識分析

    div(:class='$style[`cc-side-effect-diet-history`]')
      header(:class='$style[`cc-side-effect-diet-title`]')
        span.font-bold 我上傳的照片

      div(v-if='preloading' :class='$style[`cc-side-effect-diet-loader`]')
        div(:class='$style[`cc-side-effect-diet-loader-icon`]')
          IconLoading(:size='30' :color='`#b1b1b1`')

      div(v-else)
        ul(v-if='historyRecognize.length' :class='$style[`cc-side-effect-diet-history-ul`]')
          li(v-for='items, index in historyRecognize' :key='index' :class='$style[`cc-side-effect-diet-history-li`]')
            button(
              tabindex='0' :aria-label='`查看${items.name}`'
              :class='$style[`cc-side-effect-diet-history-btn`]'
              @click='handleClickShowDietRecognizeRecord(items)')
              div(:class='$style[`cc-side-effect-diet-history-item`]')
                span.font-medium(:class='$style[`cc-side-effect-diet-history-item-date`]') {{ items.date }}
              div(:class='$style[`cc-side-effect-diet-history-photo`]' :style='`background-image: url(${SERVER_STATIC_URL}media/${items.photo}`')
                //- img(:src='`${SERVER_STATIC_URL}media/${items.photo}`' width='100%')
                div(:class='$style[`cc-side-effect-diet-history-overlay`]')
                  IconSearch(:size='30' :color='`#fff`')

        //- LazyLoad
        infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
          div(slot='spinner')
            IconLoading(
              slot='spinner'
              :size='30'
              :color='`#b1b1b1`')
          div.infinite-scroll-slot(slot='no-more' style='padding: 25px 0 10px;')
            span.infinite-scroll-slot-noMore 沒有更多資料
          div.infinite-scroll-slot(slot='no-results' style='padding: 25px 0 10px;')
            span.infinite-scroll-slot-noMore 沒有更多資料

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { debounce } from 'debounce';
import moment from 'moment';

// import SelectModel from '../common/SelectModel';
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import IconAttachFile from '../../icon/AttachFile';
import IconRefresh from '../../icon/Refresh';
import IconDelete from '../../icon/Delete';

import GlobalEmitter from 'tiny-emitter/instance';

import {
  postDietRecognize,
  putLoadDietRecognize,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '飲食管家',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/diet',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/diet',
      }],
    };
  },

  components: {
    // SelectModel,
    IconLoading,
    IconSearch,
    IconAttachFile,
    IconRefresh,
    IconDelete,
  },

  data() {
    return {
      preloading: true,

      pageSize: 12,
      pageIndex: 1,

      foodScan: null,
      foodScanSrc: '',
      foodScanError: false,
      showFoodErrorTip: '',
      verifyAllPass: true,

      historyRecognize: [],

      abortController: new AbortController(),
      infiniteId: new Date(),
    };
  },

  created() {
    this.axiosLoadUserDietRecord();
    this.detectGlobalEmitter();
  },

  beforeDestroy() {
    this.abortController.abort();
  },

  methods: {
    ...mapMutations({
      // changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
      changePopDeleteTranslationStatus: 'global/POPDELETE_TRANSLATION_STATUS',
      changePopDietRecognizeStatus: 'global/POPDIET_RECOGNIZE_STATUS',
      // updateUserCurrentPoint: 'user/TOPBAR_USER_UPDATE_POINT',
      // updateUserTranslateCredit: 'user/USER_UPDATE_TRANSLATE_CREDIT',
    }),

    infiniteHandler($state) {
      if (!this.preloading) {
        // const jwtAccess = JSON.parse(this.authJwtToken).a;

        const USER_CONFIG = {
          auth_id: this.loginDjangoId,
          room: `0-${this.loginHashCode}-${this.loginDjangoId}`,
          page: this.pageIndex,
          size: this.pageSize,
        };

        putLoadDietRecognize('', USER_CONFIG, {})
          .then((res) => {
            res.data.results.map((x) => this.historyRecognize.push(x));
            console.log('LazyLoad ok', this.historyRecognize);

            if (res.data.results.length < this.pageSize || this.historyRecognize.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {});
      } else {
        $state.complete();
      }
    },

    detectGlobalEmitter() {
      const vm = this;
      if (vm.historyRecognize) {
        GlobalEmitter.on('diet-recognize-callback', (arg) => {
          console.log('GlobalEmitter Create', arg);
          vm.historyRecognize.unshift(arg);
          vm.resetSourceOrigin();
        });

        // GlobalEmitter.on('delete-translation', (arg) => {
        //   console.log('GlobalEmitter Delete', arg);
        //   vm.historyRecognize.splice(arg, 1);
        // });
      }
    },

    resetSourceOrigin() {
      this.foodScan = null;
      this.foodScanSrc = '';
      this.foodScanError = false;
    },

    handleClickShowDietRecognizeRecord(data) {
      this.changePopDietRecognizeStatus({
        active: true,
        detail: {
          id: data.id,
          name: data.name,
          photo: data.photo,
          ingredient: data.ingredient,
          nutritious: data.nutritious,
          completion: data.completion,
          recommend: data.recommend,
          score: data.score,
          date: data.create_date,
        },
      });
    },

    handlefoodScanUpload() {
      this.foodScanError = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs.photo.files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoBreakfast = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);

          img.onload = function () {
            if (file.size > (6000 * 1024)) {
              vm.foodScanError = true;
              vm.showFoodErrorTip = '檔案過大，需小於6MB';
            } else {
              vm.foodScan = file;
              vm.foodScanSrc = img.src;
            }
          };
        } else {
          this.foodScanError = true;
          this.showFoodErrorTip = '限 JPG / PNG 圖片格式';
          console.log('ERROR DATA TYPE', this.foodScanError);
        }
      });
    },

    axiosLoadUserDietRecord() {
      this.historyRecognize = [];

      const USER_CONFIG = {
        auth_id: this.loginDjangoId,
        room: `0-${this.loginHashCode}-${this.loginDjangoId}`,
        page: this.pageIndex,
        size: this.pageSize,
      };

      putLoadDietRecognize('', USER_CONFIG, {})
        .then((res) => {
          if (!res.data.count) {
            console.log('load empty', res.data);
          } else {
            this.historyRecognize = res.data.results;
            this.pageIndex += 1;
          }
          this.preloading = false;
          this.infiniteId += 1;
        });
    },

    axiosDietRecognize() {
      if (!this.verifyAllPass) { return; }

      this.changePopProgressStatus({
        active: true,
        feature: 'recognize',
      });

      const translateProcess = new Promise((resolve) => {
        const formData = new FormData();

        formData.append('auth_id', `${this.loginDjangoId}`);
        formData.append('user_type', this.loginProfile.user_type);
        formData.append('room', `0-${this.loginHashCode}-${this.loginDjangoId}`);

        const currentTimeStamp = moment().unix();
        console.log('currentTimeStamp', currentTimeStamp);

        if (this.foodScan) {
          const fileType = this.foodScan.type === 'image/jpeg' ? 'jpg' : 'png';
          formData.append('photo_upload', this.foodScan, `diet_${currentTimeStamp}_${this.loginDjangoId}.${fileType}`);
        }
        return resolve(formData);
      });

      translateProcess.then((fd) => {
        postDietRecognize('', fd, {
          signal: this.abortController.signal,
          headers: {
            'content-Type': 'multipart/form-data',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((res) => {
            console.log('postDietRecognize Success', res.data);
          })
          .catch((err) => {
            console.log('postDietRecognize Error', err);
            this.changePopProgressStatus({
              active: false,
              feature: '',
            });
            this.changePopBoxStatus({
              active: true,
              include: 'warnDrcellError',
            });
          });
      });
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;

      if (this.foodScanError) {
        this.verifyAllPass = false;
      }
    },

    async handleCheckProgressBeforeRecognize() {
      await this.handleFormsCheckToPass();
      await this.axiosDietRecognize();
    },

    debounceStartRecognize: debounce(async function(e) {
      this.handleCheckProgressBeforeRecognize();
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      subscribeVip: 'user/exportUserSubscribeVip',
      loginProfile: 'user/exportUserProfile',
      rwdType: 'global/exportRwdType',
      // authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectDiet.scss';
</style>
